import { combineReducers } from "redux";
import main from "../modules/Body/api/redux";
import part from "../modules/Body/api/partsRedux";
import auth from "../modules/Body/api/authRedux";

export default {
  main,
  part,
  auth,
};
